module.exports = __webpack_public_path__ + "static/media/collabrator_disable.72566665.svg";